import { ETimeoffStatus, IObjectTimecardDocument } from "../models"
import { blue500, green500, red500 } from "material-ui/styles/colors"

export function getColor500ByTimeoffStatus(status: ETimeoffStatus): string {
  switch (status) {
    case ETimeoffStatus.Requested:
      return blue500
    case ETimeoffStatus.Approved:
      return green500
    case ETimeoffStatus.Denied:
      return red500
  }
}

export function checkLeaveRequestPunch(timecard: IObjectTimecardDocument, punchId: string): boolean {
  return timecard.MasterTimecard.FullPunchSets.find(ps => (ps.PunchInId === punchId || ps.PunchOutId === punchId) && ps.TimeOffRequestId !== null) !== undefined
}